
import { CalendarDays, UserCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

export const BottomNav = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { icon: CalendarDays, label: 'Events', path: '/home' },
    {
      CustomIcon: () => (
        <img 
          src="/lovable-uploads/ac017d3e-22d1-453e-9bfd-320de782e3d5.png" 
          alt="Create Event"
          className="w-6 h-6 mb-1"
        />
      ),
      label: 'digs',
      path: '/create-event'
    },
    { icon: UserCircle, label: 'Profile', path: '/profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg">
      <div className="flex justify-around items-center h-16">
        {navItems.map(({ icon: Icon, CustomIcon, label, path }) => (
          <Link
            key={path}
            to={path}
            className={cn(
              'flex flex-col items-center justify-center w-full h-full text-xs',
              currentPath === path ? 'text-primary' : 'text-gray-500'
            )}
          >
            {CustomIcon ? <CustomIcon /> : <Icon className="w-6 h-6 mb-1" />}
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};
